"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_1 = require("./merge");
var FluentMerge = /** @class */ (function () {
    function FluentMerge() {
        this.target = null;
        this.sources = [];
        this.config = {};
    }
    /**
     * Supplies a fluent merge instance with a target object to merge into and return.
     */
    FluentMerge.prototype.to = function (target) {
        this.target = target;
        return this;
    };
    /**
     * Supplies a fluent merge instance with one or more source objects to merge from, in right to left order.
     */
    FluentMerge.prototype.from = function () {
        var sources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sources[_i] = arguments[_i];
        }
        this.sources = sources;
        return this;
    };
    /**
     * Supplies a fluent merge instance with a configuration object of one or more options.
     */
    FluentMerge.prototype.with = function (options) {
        this.config = options;
        return this;
    };
    /**
     * Executes a fluent merge instance, merging all provided sources into the
     * target, as per any provided configuration, and returning a reference to
     * the target.
     */
    FluentMerge.prototype.exec = function () {
        var _this = this;
        return this.sources.reduce(function (target, source) { return merge_1.default(target, source, _this.config); }, this.target || {});
    };
    return FluentMerge;
}());
exports.default = FluentMerge;
//# sourceMappingURL=FluentMerge.js.map